module.exports = __webpack_public_path__ + "img/500.50bd20e4.png";